import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import store from "@/store";
import Vue from "vue";
import { NavigationGuardNext, Route } from "vue-router";

export const HomeGuard = (
  to: Route,
  from: Route,
  next: NavigationGuardNext
) => {
  store.commit("setRole", localStorage.getItem(LOCAL_STORAGE.ROLE));
  store.commit("setUserName", localStorage.getItem(LOCAL_STORAGE.USER_NAME));
  store.commit("setAvatar", localStorage.getItem(LOCAL_STORAGE.AVATAR));
  Vue.directive("can", {
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    inserted: (el, binding, vnode: any) => {
      const views = JSON.parse(
        localStorage.getItem(LOCAL_STORAGE.VIEWS) ?? "[]"
      ) as string[];

      if (views.length == 0) {
        vnode.elm.style.display = "none";
      }

      const menuTag = binding.value as string[];
      if (menuTag.length > 0 && !views.some(r => menuTag.includes(r))) {
        if (
          !(
            menuTag.includes("sameUser") &&
            menuTag.includes(localStorage.getItem("UID")!)
          )
        )
          vnode.elm.parentElement?.removeChild(vnode.elm);
      }
    }
  });
  next();
};
